import PropTypes from 'prop-types';

import TableHead from './TableHead';
import TableHeadCell from './TableHeadCell';
import TableHeadRow from './TableHeadRow';

const TableHeadList = ({ list }) => (
  <TableHead>
    <TableHeadRow>
      {list.map(({ libelle }, index) => (
        <TableHeadCell key={`${libelle}-${index}`}>{libelle}</TableHeadCell>
      ))}
    </TableHeadRow>
  </TableHead>
);

TableHeadList.propTypes = {
  list: PropTypes.arrayOf({ libelle: PropTypes.string }),
};

export default TableHeadList;
